import { Tooltip } from "antd";
import dayjs from "dayjs";
import { actionViewIcon } from "../../../assets/images";
import { lang_en_US as translation } from "../../../config";

export const COMPLAINTS_HEADER_COLUMNS = ({ complaintActionRender, activeTab, complaintStatus,handleComplaintAction }) => [
    {
        title: "SNo",
        width: 60,
        render: (_, detail, index) => index + 1
    },
    {
        title: "Date",
        align: "center",
        width: 100,
        render: (detail) => <>{detail?.complaintDate ? dayjs(detail?.complaintDate).format("DD-MM-YYYY") : detail?.supportDate ? dayjs(detail?.supportDate).format("DD-MM-YYYY") : "Nil"}</>
    },
    ...(activeTab === "COMPLAINT_RAISED_LAWYER" || activeTab === "COMPLAINT_RAISED_CUSTOMER" ? [
        {
            title: "Cons. Date",
            width: 180,
            align: "center",
            render: (detail) => <>{detail?.consultationDetails?.consultationDate ? dayjs(detail?.consultationDetails?.consultationDate).format("DD-MM-YYYY") : "Nil"}</>
        },
        {
            title: "Cons. ID",
            width: 180,
            align: "center",
            render: (detail) => <>{detail?.consultationDetails?.consultationNo || "Nil"}</>
        },
        {
            title: "Customer ID",
            width: 180,
            align: "center",
            render: (detail) => {
                return <>{activeTab === "COMPLAINT_RAISED_CUSTOMER" ? (detail?.raisedByNo || "Nil") : activeTab === "COMPLAINT_RAISED_LAWYER" ? (detail?.againstByNo || "Nil") : "Nil"}</>
            }
        },
        {
            title: "Complaint Description",
            align: "center",
            dataIndex: "complaintDescription",
            width: 200,
            render: (_, detail) => {
                const description = detail?.complaintDescription || "Nil";
                if (description?.length > 30) {
                    return <Tooltip title={description}>
                        <span>{description?.slice(0, 30)}...</span>
                    </Tooltip>
                }
                return <><span>{description}</span></>
            }
        },
        {
            title: "Recorded",
            align: "center",
            width: 180,
            render: (detail) => {
                const hasRecordedStatus = detail?.consultationDetails?.consultationPaymentDetails?.recordDetail?.record === true;
                return <>
                    {
                        hasRecordedStatus ? <div className="success-status">
                            <p className="custom-header"> Recorded</p>
                        </div> : <div className="danger-status">
                            <p className="custom-header">Not Recorded</p>
                        </div>
                    }
                </>
            }
        },
        {
            title: "Complaint Status",
            align: "center",
            width: 180,
            render: (detail) => {
                return <>{
                    detail?.complaintStatus && detail?.complaintStatus === "PENDING" ? <div className="pending-status"><p>Pending</p></div>
                        : detail?.complaintStatus && detail?.complaintStatus === "COMPLETED" ? <div className="success-status"><p>Completed</p></div> : <div>Nil</div>
                }</>
            }
        }
    ] : []),
    ...(activeTab === "support" ? [{
        title: "Support Description",
         width:250,
        dataIndex: "description",
        render: (_, detail) => {
            const description = detail?.description || "Nil";
            if (description?.length > 40) {
                return <Tooltip title={description}>
                    <span>{description?.slice(0, 40)}...</span>
                </Tooltip>
            }
            return <><span>{description}</span>
            </>
        }
    },
    ] : []),
    ...(complaintStatus === "COMPLETED" ? [
        {
            title: "Action Taken",
            width:250,
            render: (detail) => {
                return <>{detail?.actionItem || "Nil"}</>
            }
        },
        ...(activeTab !== "support" ? [
            {
                title:"Action Type",
                width:150,
                render:(detail)=>{
                    return<>{detail?.complaintActionType || "Nil"}</>
                }
            },
            {
                title:"Warned By",
                width:150,
                render:(detail)=>{
                    const warnedByName=detail?.warnedByName || "Nil";
                    if(warnedByName?.length>20){
                        return<Tooltip title={warnedByName}>
                            <span>{warnedByName?.slice(0,20)}...</span>
                        </Tooltip>
                    }
                    return<>{warnedByName}</>
                }
            }
        ] : [])
    ] : []),
    {
        title: "Action",
        width: 80,
        fixed: "right",
        render: (detail) => activeTab === "support" ? <><img src={actionViewIcon} onClick={()=>handleComplaintAction("view",detail)} alt="" style={{ cursor: "pointer" }} /></> : complaintActionRender(detail)
    }
];

export const complaintesTabData = [
    { label: "Complaints Against Advocate", content: translation?.lawyerManagement?.complaintsAgaintlawerTitle, key: "1" },
    { label: "Complaints Raised Advocate", content: translation?.lawyerManagement?.complaintsRaisedlawyerTitle, key: "2" },
    { label: "Support", content: "support", key: "3" }
];

export const complaintStatus = [
    { key: "PENDING", value: "Pending" },
    { key: "COMPLETED", value: "Completed" }
];

export const messageTabData = [
    { key: 1, label: "Raised By", content: "raised" },
    { key: 2, label: "Against By", content: "against" }
];